import * as React from "react";
import {cx} from "emotion";

import "./bubble-noti-2.scss";

import {cs}            from "../../react/chain-services";
import {fragments}     from "../../react/fragments";
import {keyed}         from "../../react/keyed";
import {OnMounted}     from "../../react/on-mounted";
import {Static2}       from "../../react/static-2";
import {TimeoutAction} from "../../react/timeout-action";
import {UseState}      from "../../react/use-state";
import {randomId}      from "../../utils/random";
import {waitTimeout}   from "../../utils/wait-timeout";

export const BubbleNoti2 = ({next}) => cs(
    ["messages", (_, next) => UseState({initValue: [], next})],
    ["top", (_, next) => next((() => {
        const scrollTop = (
            document.documentElement.scrollTop ? (
                document.documentElement.scrollTop
            ): (
                document.body.scrollTop
            )
        );

        return Math.max(10, 100 - scrollTop);
    })())],
    ({messages, top}, next) => fragments(
        next(),
        // console.log(window.scrollTop),
        (
            <div className="bubble-noti-2-5ri" style={{top}}>
                {messages.value?.map(({id, content, duration}) => cs(
                    keyed(id),
                    ["slideAnimation", (_, next) => SlideAnimation({next})],
                    ({slideAnimation}, next) => fragments(
                        next(),
                        OnMounted({
                            action: () => slideAnimation.slideDown(),
                        })
                    ),
                    ["close", ({slideAnimation}, next) => next(async () => {
                        await slideAnimation.slideUp();
                        messages.change((_) => _.filter((m) => m.id !== id));
                    })],
                    ({close}, next) => fragments(
                        next(),
                        TimeoutAction({
                            delay: duration,
                            action: close,
                        })
                    ),
                    ({slideAnimation, close}) => (
                        <div className={cx("message")} ref={slideAnimation.ref}>
                            <div className="padding"/>

                            <div className="content">
                                <div className="icon">
                                    <i className="fa fa-check"/>
                                </div>
                                <div className="right">
                                    <div className="text">
                                        {content}
                                    </div>
                                    <div {...{
                                        className: "close",
                                        onClick: close,
                                    }}>
                                        &times;
                                    </div>
                                </div>
                            </div>

                            <div className="padding"/>
                        </div>
                    ),
                ))}
            </div>
        )
    ),
    ({messages}) => next({
        addMessage: ({content, duration=6000}) => messages.change((_) => [
            ..._, {
            id: randomId(),
            content,
            duration,
        }]),
    }),
);

const SlideAnimation = ({next}) => cs(
    ["domRef", (_, next) => Static2({next})],
    ({domRef}) => next({
        ref: domRef.set,
        slideDown: async () => {
            const dom = domRef.get();
            const oriHeight = dom.getBoundingClientRect().height;
            dom.style.height = 0;
            dom.style.overflow = "hidden";
            dom.style.transition = "opacity 300ms ease, height 300ms ease";
            await waitTimeout(30);

            dom.style.opacity = 1;
            dom.style.height = oriHeight + "px";

            await waitTimeout(300);

            delete dom.style.height;
            dom.style.overflow = "visible";
        },
        slideUp: async () => {
            const dom = domRef.get();
            dom.style.height = dom.getBoundingClientRect().height;
            dom.style.overflow = "hidden";
            dom.style.transition = "opacity 300ms ease, height 300ms ease";
            await waitTimeout(30);

            dom.style.opacity = 0;
            dom.style.height = 0;

            await waitTimeout(300);

        },
    }),
);


